import { FC, useEffect } from 'react'
import cn from 'classnames'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import iclasses from '@pages/Admin/CRM/styles/input.module.css'
import jclasses from '@pages/Admin/CRM/styles/jsmodal.module.css'
import { Select } from 'antd'
import { ElClassFormDataType } from '../PageContent/PageContent'

interface TariffSelectProps {
  group: NonNullable<ElClassFormDataType['groups']>[number]
  handleSelectTariff: (key: any, tariffId: number | null | undefined) => void
  className?: string
}

const TariffSelect: FC<TariffSelectProps> = ({ group, handleSelectTariff, className }) => {
  const options = group?.id
    ? group?.direction?.tariffs?.map((tar) => ({
        label: tar?.name,
        value: tar?.id,
      })) ?? []
    : []

  useEffect(() => {
    if (options.length === 1 && group?.id) {
      const singleTariffId = options[0].value
      if (group?.tariff_id !== singleTariffId) {
        handleSelectTariff(group?.key, singleTariffId)
      }
    }
  }, [options, group?.id, group?.key, group?.tariff_id, handleSelectTariff])

  return (
    <Select
      showSearch
      className={cn(iclasses.newSelect, className)}
      popupClassName={iclasses.newSelectPopup}
      onChange={(id) => handleSelectTariff(group?.key, id)}
      value={group?.tariff_id}
      placeholder="Выберите тариф"
      filterOption={(input, option) =>
        (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase())
      }
      options={options}
      notFoundContent={
        group?.id ? 'Нет доступных тарифов' : 'Сначала выберите группу'
      }
    />
  )
}

export default TariffSelect
